:host {
  display: block;
  box-sizing: border-box;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

.range-node-link {
  display: block;
  text-decoration: none;
}

.range-node-link:hover {
  text-decoration: none;
}

.range-node-link:visited {
  outline: none;
}

.range-node-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 280px;
  height: 242px;
  border: 1px solid #e7e6e6;
  background-color: #ffffff;
}

.range-node-card:hover {
  text-decoration: none !important;
}

.range-node-card:visited {
  outline: none !important;
}

.range-node-card__img-wrapper {
  margin-top: 30px;
}

.range-node-card__img-wrapper img {
  width: 140px;
  height: 140px;
}

.range-node-card__label-wrapper {
  align-self: flex-start;
}

:host(:not([dir="rtl"])) .range-node-card__label-wrapper {
  margin-left: 30px;
}

:host([dir="rtl"]) .range-node-card__label-wrapper {
  margin-right: 30px;
}

.range-node-card__label {
  color: #626469;
  text-decoration: none;
}